/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminUpdateSurveyMarkSubmissions } from '../../models/admin-update-survey-mark-submissions';
import { SurveyMarksSubmissionDto } from '../../models/survey-marks-submission-dto';

export interface AdminUpdateSurveyMarkSubmission$Params {
  submissionId: number;
  body: AdminUpdateSurveyMarkSubmissions;
}

export function adminUpdateSurveyMarkSubmission(
  http: HttpClient,
  rootUrl: string,
  params: AdminUpdateSurveyMarkSubmission$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksSubmissionDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    adminUpdateSurveyMarkSubmission.PATH,
    'put',
  );
  if (params) {
    rb.path('submissionId', params.submissionId, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksSubmissionDto>;
      }),
    );
}

adminUpdateSurveyMarkSubmission.PATH =
  '/admin/surveyMarks/submissions/{submissionId}';
